<template>
<!-- <CompanyPolicy></CompanyPolicy> -->
<div class="col-xxl-12 mb-5">
    <!-- <ECShopAdvisory></ECShopAdvisory> -->
  </div>
  <div class="col-xxl-12  mb-5">
    <!-- <BalanceDetails
      widget-classes="card-xxl-stretch mb-5 mb-xxl-8"
    ></BalanceDetails> -->
  </div>
  <div v-show="loading"> 
 	  <el-skeleton :rows="10" animated />
  </div>
  <div class="col-xxl-12" v-show="!loading">
      <!--begin::Reorder History-->
    <div :class="widgetClasses" class="card" >
      <!--begin::Header-->
      <div class="card-header border-0 pt-5">
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label fw-bolder fs-3 mb-1">Retail Sales</span>
        </h3>
      </div>
      <!--end::Header-->

      <!--begin::Body-->
      <div class="card-body py-3">
        <!--begin::Table container-->
        <div class="table-responsive">
          <!--begin::Table-->
          <table class="table align-middle gs-0 gy-4">
            <!--begin::Table head-->
            <thead>
              <tr class="fw-bolder text-muted bg-light">
                <th class="ps-4 min-w-125px rounded-start">#</th>
                <th class="min-w-200px">Customer Name</th>
                <th class="min-w-225px">Date</th>
                <th class="min-w-200px">Product Name</th>
                <th class="min-w-200px">Quantity</th>
                <th class="min-w-200px">Income</th>
              </tr>
            </thead>
            <!--end::Table head-->
            <!--begin::Table body-->
            <tbody>
              <template v-for="(item, index) in list" :key="index">
                <tr>
                  <td>&nbsp;&nbsp;&nbsp;{{item.id}}</td>
                  <td>{{item.custname}}</td>
                  <td>{{item.terminal_date}}</td>
                  <td>{{item.prodname}}</td>
                  <td>{{item.qty}}</td>
                  <td>{{item.income}}</td>
                </tr>
              </template> 
            </tbody>
            <!--end::Table body-->
          </table>
          <!--end::Table-->
        </div>
        <!--end::Table container-->
      </div>
      <!--begin::Body-->
    </div>
  <!--end::Reorder History-->
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import {loadPaginatedECSales}  from "@/api/onlineshop";
// import BalanceDetails from "@/components/cards/BalanceDetails.vue";
// import CompanyPolicy from "@/components/companypolicy/CompanyPolicy.vue";
// import ECShopAdvisory from  "@/views/ECShopAdvisory.vue";

export default defineComponent({
  name: "retailsales",
  components: {
    // BalanceDetails,
    // CompanyPolicy,
    // ECShopAdvisory
  },
  data() { 
    return { 
      list : [],
      loading: true,
    }
  },
  mounted(){
      this.loadPaginatedECSales();
  },
  methods : {
    async loadPaginatedECSales(){ 
      this.loading = true;
      const response = await loadPaginatedECSales(1);
      this.list = response.data.pageList;
      this.loading = false;
    },
  },
  setup() {
    const tabIndex = ref(0);

    onMounted(() => {
      // set the tab from previous
      tabIndex.value = parseInt(localStorage.getItem("onlineShopTab") || "0");
      setCurrentPageTitle("Online Shop");

    });
    
  }
});
</script>
